(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.hu = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Nem találhatók adatok'
      },
      combobox: {
        placeholder: 'Kijelölés',
        searchPlaceholder: 'Keresés'
      },
      datepicker: {
        apply: 'Alkalmaz',
        clearSelection: 'Törlés',
        pickADays: 'Napok kiválasztása',
        prevYear: 'Előző év',
        nextYear: 'Következő év',
        prevMonth: 'Előző hónap',
        nextMonth: 'Következő hónap',
        year: '',
        month1: 'Január',
        month2: 'Február',
        month3: 'Március',
        month4: 'Április',
        month5: 'Május',
        month6: 'Június',
        month7: 'Július',
        month8: 'Augusztus',
        month9: 'Szeptember',
        month10: 'Október',
        month11: 'November',
        month12: 'December',
        weeks: {
          sun: 'V',
          mon: 'H',
          tue: 'K',
          wed: 'Sze',
          thu: 'Cs',
          fri: 'P',
          sat: 'Szo'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Márc',
          apr: 'Ápr',
          may: 'Május',
          jun: 'Jún',
          jul: 'Júl',
          aug: 'Aug',
          sep: 'Szept',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Dec'
        },
        pickADay: 'Nap kiválasztása'
      },
      timepicker: {
        meridiemAM: 'de.',
        meridiemPM: 'du.'
      },
      dropdown: {
        noDataMessage: 'Nem találhatók adatok'
      },
      filepicker: {
        browse: 'Tallózás',
        select: 'Fájl kiválasztása'
      },
      filter: {
        apply: 'Alkalmaz',
        cancel: 'Mégse',
        filterButton: 'Szűrő',
        reset: 'Szűrők visszaállítása',
        resetDefault: 'Alapértékek visszaállítása'
      },
      search: {
        noDataMessage: 'Nem találhatók adatok'
      },
      'multi-search': {
        'separator-and': 'ÉS',
        'search-button': 'Keresés',
        'search-placeholder': 'Keresés név alapján'
      },
      select: {
        all: 'Mind',
        clearSelection: 'Kijelölés megszüntetése',
        noMatch: 'Nem találhatók adatok',
        noData: 'Nincsenek adatok',
        placeholder: 'Kijelölés',
        item: 'elem',
        selected: 'kiválasztva',
        found: 'található'
      },
      upload: {
        browseButton: 'Tallózás',
        text: 'Húzza ide a feltöltendő fájlokat, vagy kattintson a Tallózás elemre',
        tip: '10, egyenként legfeljebb 25 MB méretű fájlt tölthet fel'
      },
      table: {
        emptyText: 'Nincs adat'
      },
      tree: {
        emptyText: 'Nincs adat'
      }
    }
  };
  _exports.default = _default;
});